module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10070.ac3dc510.jpg";